export default (props) => {
    const { BlockControls } = wp.blockEditor;
    const { ToolbarDropdownMenu } = wp.components;
    // Ce component a besoins que le bloc dans lequel il est aie l'attribut string align

    const AlignIcons = (icon) =>{ 
        if(icon == 'align-full'){
            return 'align-full-width';
        } 
        if(icon == 'align-wide'){
            return 'align-wide';
        }

        return 'align-center';
    }

    return <BlockControls>
                <ToolbarDropdownMenu
                    icon={ AlignIcons(props.attributes.align) }
                    label={wp.i18n.__("Select the width of the content","theme-client")}
                    controls={ [
                        {
                            title: wp.i18n.__( "Default","theme-client" ),
                            icon: "align-center",
                            onClick: () => props.setAttributes( { align: "" } ),
                            isDisabled: props.attributes.align == "",
                        },
                        {
                            title: wp.i18n.__( "Align wide width","theme-client" ),
                            icon: "align-wide",
                            onClick: () => props.setAttributes( { align: "align-wide" } ),
                            isDisabled: props.attributes.align == "align-wide",
                        },
                        {
                            title: wp.i18n.__( "Align full width","theme-client" ),
                            icon: "align-full-width",
                            onClick: () => props.setAttributes( { align: "align-full" } ),
                            isDisabled: props.attributes.align == "align-full",
                        }
                    ] }
                />
            </BlockControls>
}
